import { Field, NumericInput, RadioGroup } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import externalTestMethods from 'Components/Worksheets/ExternalTestMethods';
import { ParticleDensityDeterminationMethod } from 'Components/Worksheets/MaximumDryDensityWorksheet/types';
import { hasValue } from 'Lib/Any';
import React from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';

let BsTestFractionParticleDensitySection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const particleDensityDeterminationMethod = useSelector(
    pipe(createWorksheetSelector!('TestFractionParticleDensity.ParticleDensityDeterminationMethod'))
  ) as ParticleDensityDeterminationMethod;

  const particleDensityHasValue = useSelector(
    pipe(createWorksheetSelector!('TestFractionParticleDensity.ParticleDensity'), hasValue)
  );

  return (
    <>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name={'TestFractionParticleDensity.ParticleDensityDeterminationMethod'}
          options={[
            { label: 'Assumed', value: ParticleDensityDeterminationMethod.Assumed },
            { label: 'Measured', value: ParticleDensityDeterminationMethod.Measured },
          ]}
          confirm={() =>
            (particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Assumed ||
              particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Measured) &&
            particleDensityHasValue
          }
          confirmText="The particle density determination method will be changed, overwriting any existing data."
        />
        <Field
          input={<NumericInput />}
          name="TestFractionParticleDensity.ParticleDensity"
          visible={particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Assumed}
        />
      </ListFieldSection>
      {particleDensityDeterminationMethod === ParticleDensityDeterminationMethod.Measured && (
        <WorksheetAssociatedTestSection
          name="TestFractionParticleDensity.AssociatedTestFractionParticleDensity"
          heading="Test Fraction Particle Density - External source (final results only)"
          testType="Particle Density"
          associatedTestModel={{
            external: {
              testMethods: [externalTestMethods.particleDensity.BS_1377_2_Clause_9_2],
              permitOtherTestMethods: false,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    name="TestFractionParticleDensity.AssociatedTestFractionParticleDensity.ExternalTest.Results.ParticleDensity"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </>
  );
};

BsTestFractionParticleDensitySection = withInjectedProps(BsTestFractionParticleDensitySection);

export { BsTestFractionParticleDensitySection };
export default BsTestFractionParticleDensitySection;
